
import { Options } from 'vue-class-component';
import { ItemsActionName } from '@/definitions/app/item.actions.name';
import { actionHandler } from '@/store/data/ActionHandler';
import { actionsModule } from '@/store/data/ActionsModule';
import { Action } from '@/uikit';
import NButton from '@/uikit/buttons/NButton.vue';
import NThumbnail from '@/uikit/thumbnail/NThumbnail.vue';
import { hasParentElementDataName } from '@/common/utils';
import CardAttachments from '@/components/cards/CardAttachments.vue';
import CardDate from '@/components/cards/CardDate.vue';
import CardItem from '@/components/cards/CardItem';
import CardMetafields from '@/components/cards/CardMetafields.vue';
import ActionsDropdown from '@/components/common/ActionsDropdown.vue';
import WatchListsGroup from '@/components/common/WatchListsGroup.vue';
import { copyTextToClipboard } from '@/uikit/helpers';
import NHint from '@/uikit/hint/NHint.vue';
import NIcon from '@/uikit/icons/NIcon.vue';

const CommentMaxLength = 1500;

@Options({
  name: 'CardItemRow',
  components: { ActionsDropdown, CardAttachments, CardDate, CardMetafields, NButton, NHint, NIcon, NThumbnail, WatchListsGroup }
})
export default class CardItemRow extends CardItem {
  get cardActions(): Action[] {
    return actionsModule
      .getItemActions(this.modelAcl, {
        hasSearch: true,
        hasCardFilterEvent: true,
        hasActive: true,
        hasDelete: true,
        hasAddToMonitoring: !this.hasAnyMonitoringRecord,
        hasRemoveFromMonitoring: this.hasCardMonitoringRecord,
        hasPuppeteerExternalSearch: true,
        currentActive: this.item.active
      })
      .map(actionsModule.computeActionByName);
  }

  get formattedName() {
    return this.$filters.shortString(this.name, 125);
  }

  get formattedComment() {
    return this.$filters.shortString(this.comment, CommentMaxLength);
  }

  get classes() {
    return {
      'card-item-row': true,
      'card-item-row__selected': this.selected,
      'card-item-row__opened': this.opened
    };
  }

  actionHandler(v: ItemsActionName) {
    actionHandler.run(v, { type: `cards_${this.type}`, rawItem: this.item });
  }

  idClickHandler(text: string | number) {
    copyTextToClipboard(String(text));
  }

  clickHandler(e: Event) {
    let isActionClick = hasParentElementDataName(e.target as HTMLElement, 'actions');
    if (!isActionClick) this.$emit('select');
  }
}
